<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="printWindow()" />
                            <Button label="Pdf" v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12px;" v-if="dataDocument">
                    <tbody>
                         <tr style="text-align:center;font-size:15px;">
                            <td colspan="10"> 
                                <p>
                                    <span style="font-weight:bold;">No. BAST: {{dataDocument.Doc_No}}<br/>BERITA ACARA SERAH TERIMA (BAST)</span><br/>
                                    <span style="font-size:12px;"><i>THE OFFICIAL HANDOVER</i></span>

                                </p>
                            </td>
                        </tr>
                        <tr style="height:10px;">
                            <td colspan="10"><hr/></td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="5"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="2" style="">NO SPO</td>
                            <td colspan="6" style="">:  {{dataDocument.No_SPO != null ? dataDocument.No_SPO : "-"}}</td>
                            <td colspan="2" style="text-align:center;border: 1px solid black;">Tgl Penerimaan</td>
                        </tr>
                        <tr>
                            <td colspan="2">TANGGAL SPO</td>
                            <td colspan="6">: {{dataDocument.Tanggal_SPO != null ? this.$formatDate(dataDocument.Tanggal_SPO) : "-"}}</td>
                            <td colspan="2" style="text-align:center;border: 1px solid black;">{{this.$formatDate(dataDocument.Tanggal_Penerimaan)}}</td>
                        </tr>
                        <tr>
                            <td colspan="2">PEKERJAAN</td>
                            <td colspan="8">: {{dataDocument.Pekerjaan}}</td>
                           
                        </tr>
                        <tr>
                            <td colspan="2">WAKTU PENYELESAIAN</td>
                            <td colspan="8">: {{dataDocument.Waktu_Penyelesaian}} Hari</td>
                           
                        </tr>
                        <tr>
                            <td colspan="10" style="font-weight:bold;">A. PROGRESS*</td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;">
                            <td rowspan="2" colspan="3" style="border: 1px solid black"></td>
                            <td rowspan="2" style="border: 1px solid black">SCHEDULE DATE</td>
                            <td rowspan="2" style="border: 1px solid black">ACTUAL DATE</td>
                            <td colspan="2" style="border: 1px solid black">RESULT</td>
                            <td colspan="3" style="border: 1px solid black">PIC</td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;">
                            <td style="border: 1px solid black;">ON TARGET</td>
                            <td style="border: 1px solid black;">DELAY</td>
                            <td style="border: 1px solid black;">SIGN</td>
                            <td colspan="2" style="border: 1px solid black;">NAMA</td>
                        </tr>
                        <tr v-for="item in dataDocument.Progresses" :key="item.Id">
                            <td colspan="3" style="border: 1px solid black;">{{item.Task}} <span v-if="item.Task == 'Progress'">{{item.Unit}}%</span></td>
                            <td style="text-align:center;border: 1px solid black;">{{this.$formatDate(item.Sch_Date)}}</td>
                            <td style="text-align:center;border: 1px solid black;">{{this.$formatDate(item.Act_Date)}}</td>
                            <td style="text-align:center;border: 1px solid black;">{{item.Result == "ON TARGET" && item.Result !=null ? "V" :""}}</td>
                            <td style="text-align:center;border: 1px solid black;">{{item.Result != "ON TARGET"  && item.Result !=null ? "V" :""}}</td>
                            <td style="text-align:center;border: 1px solid black;">{{item.Sign}}</td>
                            <td colspan="2" style="text-align:center;border: 1px solid black;">{{item.Name}}</td>
                        </tr>
                        <tr style="height:10px;">
                            <td colspan="10">*Diisi oleh Contractor dan cek PIC</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="10"></td>
                        </tr>
                        <tr>
                            <td colspan="10" style="font-weight:bold;">B. EVALUASI KERJA**</td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="3" style="font-weight:bold;border: 1px solid black;"></td>
                            <td style="font-weight:bold;border: 1px solid black;">BAIK</td>
                            <td style="font-weight:bold;border: 1px solid black;">TIDAK BAIK</td>
                            <td style="font-weight:bold;border: 1px solid black;">BERSIH</td>
                            <td style="font-weight:bold;border: 1px solid black;">TIDAK BERSIH</td>
                            <td colspan="3" style="font-weight:bold;border: 1px solid black;">REMARKS</td>
                        </tr>
                      
                        <tr v-for="item in dataDocument.Evaluasis" :key="item.Id">
                            <td colspan="3" style="border: 1px solid black;">{{item.Task}}</td>
                            <td style="text-align:center;border: 1px solid black;" :class="{'background' : item.Task == 'Kebersihan'}">
                                <span v-if="item.Result == 'BAIK'">V</span>
                            </td>
                            <td style="text-align:center;border: 1px solid black;" :class="{'background' : item.Task == 'Kebersihan'}">
                                <span v-if="item.Result == 'TIDAK BAIK'">V</span>
                            </td>
                            <td style="text-align:center;border: 1px solid black;" :class="{'background' : item.Task != 'Kebersihan'}">
                                <span v-if="item.Result == 'BERSIH'">V</span>
                            </td>
                            <td style="text-align:center;border: 1px solid black;" :class="{'background' : item.Task != 'Kebersihan'}">
                                <span v-if="item.Result == 'TIDAK BERSIH'">V</span>
                            </td>
                            <td colspan="3" style="text-align:center;border: 1px solid black;">{{item.Remarks}}</td>
                        </tr>
                        <tr style="height:10px;">
                            <td colspan="10">*Diisi oleh PIC</td>
                        </tr>
                        
                        <tr style="height:15px;">
                            <td colspan="10"></td>
                        </tr>
                        <tr>
                            <td colspan="10">
                                <p align="justify">                                
                                    Bersama ini kami {{dataDocument.company}} dan {{dataDocument.contractor}} menyatakan telah bersama-sama 
                                    melakukan pemeriksaan pekerjaan tersebut dan {{dataDocument.company}} menyatakan: <br/>
                                    <span><input type="checkbox" v-model="is_receive" class="disabled" value="Menerima"/></span>Menerima, pekerjaan telah dilaksanakan sesuai dengan instruksi dari pelaksana project<br/>
                                    <span><input type="checkbox" v-model="is_not_receive" class="disabled" value="Tidak Bisa Menerima"/></span>Tidak bisa menerima, kontraktor harus membongkar dan atau memperbaiki dalam waktu 2 (dua) minggu. 
                                    Pemeriksaan ulang dilakukan setelah pekerjaan selesai dikerjakan<br/>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10">
                                <div>
                                    <p style="text-align: justify;"><span style="color:black;font-weight:bold;">Dengan diterimanya pekerjaan tersebut diatas oleh Wilmar, maka disepakati bahwa:</span>:
                                    </p> 
                                    <ol class="ol">
                                        <li>Pekerjaan telah diselesaikan sesuai dengan design, BoQ, dan diselesaikan sesuai dengan waktu yang tertulis di atas </li>
                                        <li>Pekerjaan memasuki masa pemeliharaan/retensi selama 90 hari kalender yang terhitung setelah tanggal selesai pekerjaan selesai 100%</li>
                                        <li>Segala kerusakan dan cacat tersembunyi selama masa pemeliharaan/retensi menjadi tanggung jawab penuh Kontraktor</li>
                                    </ol>
                                    <p>Demikian Berita Acara Serah Terima ini dibuat dengan sebenarnya untuk dapat dipergunakan sebagaimana mestinya</p>
                                </div>
                            </td>
                        </tr>
                        <tr style="font-weight:bold;text-align:center;">
                            <td colspan="4" style="border: 1px solid black;">Diajukan oleh kontraktor,</td>
                            <td colspan="3" style="border: 1px solid black;">Diperiksa oleh project,</td>
                            <td colspan="3" style="border: 1px solid black;">Disetujui oleh,</td>
                        </tr>
                        <tr style="height:15px;text-align:center;">
                            <td rowspan="7" colspan="4" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As1 ? '' :'rgb(200, 200, 200)' }">
                                <p v-if="dataDocument.Appr_Name1">
                                    <span class="fontsign">{{dataDocument.Appr_Name1}}</span> <br/>
                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                </p>
                            </td>
                            <!-- <td rowspan="4" style="border: 1px solid black;"></td> -->
                            <td colspan="3" rowspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As2 ? '' :'rgb(200, 200, 200)' }">
                                <p v-if="dataDocument.Appr_Name2">
                                    <span class="fontsign">{{dataDocument.Appr_Name2}}</span> <br/>
                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                </p>
                            </td>
                            <!-- <td rowspan="4" style="border: 1px solid black;"></td> -->
                            <td colspan="3" rowspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As4 ? '' :'rgb(200, 200, 200)' }">
                                <p v-if="dataDocument.Appr_Name4!=null">
                                    <span class="fontsign">{{dataDocument.Appr_Name4}}</span> <br/>
                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate4)}}</span>
                                </p>
                            </td>
                            <!-- <td rowspan="4" style="border: 1px solid black;"></td> -->
                        </tr>
                        <tr style="height:15px;">
                          
                        </tr>
                        <tr style="height:15px;">
                           
                        </tr>
                        <tr style="height:15px;text-align:center;">
                          
                            
                            <td colspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As1 ? '' :'rgb(200, 200, 200)' }"><i>{{dataDocument.Appr_As1}}</i></td>
                            <td colspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As4 ? '' :'rgb(200, 200, 200)' }"><i>{{dataDocument.Appr_As4}}</i></td>

                        </tr>
                        <tr style="height:15px;text-align:center;">
                            <!-- <td rowspan="4" style="border: 1px solid black;"></td> -->
                            <td rowspan="3" colspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As3 ? '' :'rgb(200, 200, 200)' }">
                                <p v-if="dataDocument.Appr_Name3">
                                    <span class="fontsign">{{dataDocument.Appr_Name3}}</span> <br/>
                                    <span>{{this.$formatDateTime1(dataDocument.ApprDate3)}}</span>
                                </p>
                            </td>
                            <!-- <td rowspan="4" style="border: 1px solid black;"></td> -->
                            <!-- <td colspan="3" style="border: 1px solid black;"><i>VERIFIED</i></td> -->
                            <td colspan="3" rowspan="4" style="border: 1px solid black;"></td>
                        </tr>
                        <tr style="height:15px;">
                           
                            <!-- <td colspan="3" rowspan="3" style="border: 1px solid black;"></td> -->
                        </tr>
                        <tr style="height:15px;">
                        </tr>
                        <tr style="height:15px;text-align:center;">
                            <td colspan="4" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As2 ? '' : 'rgb(200, 200, 200)' }"><i>{{dataDocument.Appr_As2}}</i></td>
                            <td colspan="3" style="border: 1px solid black;" :style="{ backgroundColor: dataDocument.Appr_As3 ? '' : 'rgb(200, 200, 200)' }"><i>{{dataDocument.Appr_As3}}</i></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5" class="tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" style="margin-top:-10px;" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td colspan="5" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:120px;float:right;margin-top:-1px;"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10"  v-if="dataDocument.is_aproved" style="font-size:10px;font-weight: bold;">
                                {{ this.signBy(dataDocument)}}
                            </td>
                        </tr>
                        <tr style="height: 10px;">
                            <td style="border: none;"></td>
                        </tr>
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>

</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {
        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgdocumentation : "",
        companydetail : null,
        is_receive :false,
        is_not_receive : false,
        valueLink : this.$store.getters.getUrlApp + this.$route.fullPath
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/BaFinal/Index" });
    },
    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.ceil(table.scrollHeight / 1123);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            pageNumberDiv.style.top = "calc((281mm - (0.5px + " + (i+1) +"px)) * " + (i+1)+ " -  31px)";
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            //pageNumberDiv.style.marginBlockStart = "30px"
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        
        html2pdf(this.$refs.document, {
            margin:10,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "BaFinal/getDataDoc/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgdocumentation = data.imgdocumentation;
                self.companydetail = data.companydetail;
                self.is_receive = data.document.Status_Pekerjaan == "Menerima";
                self.is_not_receive = data.document.Status_Pekerjaan == "Tidak Bisa Menerima";
              
                let addlinkqr = "";
                if(self.dataDocument.No_SPO != null && self.dataDocument.progress != null)
                    addlinkqr="&SPO=" + self.dataDocument.No_SPO + "&T="+self.dataDocument.progress;
                else if(self.dataDocument.No_SPO != null && self.dataDocument.progress != null)
                    addlinkqr="&SPO=" + self.dataDocument.No_SPO;
                else if(self.dataDocument.No_SPO != null && self.dataDocument.progress != null)
                    addlinkqr="&T="+self.dataDocument.progress;
                
                this.valueLink = this.$store.getters.getUrlApp + this.$route.fullPath + addlinkqr;

                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>
@page {
    size: A4 portrait;
    margin: 10mm;
}
@media print {
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
     }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: auto;
    }
    .tdfoot{
        width: 700px;
    }

    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }
}
.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}


.disabled{
    pointer-events: none;
}
.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top:2px solid black;
}

#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .background{
    background-color: rgb(200, 200, 200);;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>